import styled from 'styled-components';

export const BannerWrapper = styled.div`
  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  z-index: 1000;
  overflow: hidden;
`;
